module.exports = __webpack_public_path__ + "media/images/FTRP_SME_banner-8cc2b551548afd0ff4de63f17ff868b4.jpg";